import { Component, Inject, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { MsalBroadcastService, MsalService, MSAL_INSTANCE } from './core/msal';
import { IPublicClientApplication} from '@azure/msal-browser';
import { MsalGuardConfiguration } from './core/msal/msal.guard.config';
import { MSAL_GUARD_CONFIG } from './core/msal/constants';

import { TranslateService } from '@ngx-translate/core';
import { Subject, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'bid-cp';

  private _router: Subscription;

  loggedIn = false;

  private readonly _destroying$ = new Subject<void>();

  constructor(private router: Router,
    private translate: TranslateService,
    private authService: MsalService,
    @Inject(MSAL_INSTANCE) public instance: IPublicClientApplication,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private msalBroadcastService: MsalBroadcastService) {
    localStorage.setItem('status', '');
    translate.setDefaultLang('es');
  }

  async ngOnInit() {
    this.authService.handleRedirectObservable().subscribe({
      next: (result) => {
        if (result != null) {
          localStorage.setItem("idToken", result.idToken)
          localStorage.setItem("scopes", JSON.stringify(result.scopes))
          localStorage.setItem("username", result.account.username)
          localStorage.setItem("name", result.account.name)
          localStorage.setItem("claims", JSON.stringify(result.idTokenClaims))
          localStorage.setItem("accessToken", result.accessToken)
          localStorage.setItem("expiresOn", JSON.stringify(result.expiresOn))
        }
      },
      error: (error) => console.log("ERROR", error)
    });

    this._router = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      const body = document.getElementsByTagName('body')[0];
      const modalBackdrop = document.getElementsByClassName('modal-backdrop')[0];
      if (body.classList.contains('modal-open')) {
        body.classList.remove('modal-open');
        modalBackdrop.remove();
      }
    })
  }

  checkAccount() {
    this.loggedIn = this.authService.instance.getAllAccounts().length > 0;
    console.log("this.loggedIn", this.loggedIn);
  }

  ngOnDestroy(): void {
    this._destroying$.next(null);
    this._destroying$.complete();
  }
}
